import { Stack, TextField, IconButton } from "@mui/material";
import { Save } from "@mui/icons-material";
import { useState } from "react";

export default function Range({start, end, onChange, sx, ready}){

    const [changed, setChanged] = useState(ready || false);

    const handleSubmit = e => {
        e.preventDefault();
        setChanged(false);
        return onChange({
            start: e.target.start.value, 
            end: e.target.end.value
        });
    }

    return (start && end) && <form onSubmit={handleSubmit}>

        <Stack direction='row' spacing={1} alignItems='center' sx={sx}>
            
            <TextField
                label='Du'
                type='date'
                name='start'
                defaultValue={start || ''}
                onChange={() => setChanged(true)}
                InputLabelProps={{shrink: true}}
                size='small'
            />

            <TextField
                label='Au'
                type='date'
                name='end'
                defaultValue={end || ''}
                onChange={() => setChanged(true)}
                InputLabelProps={{shrink: true}}
                size='small'
            />

            <IconButton type='submit' disabled={!changed} size='small'>
                <Save color={changed ? 'primary' : 'inherit'} />
            </IconButton>

        </Stack>

    </form>
}